// extracted by mini-css-extract-plugin
export var box = "_1i-1";
export var checked = "_1i-2";
export var descriptionSpacer = "_1i-9";
export var disabled = "_1i-3";
export var icon = "_1i-6";
export var input = "_1i-0";
export var labelSpacer = "_1i-8";
export var medium = "_1i-5";
export var small = "_1i-4";
export var text = "_1i-7";